// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PeopleBranchSvg from '@rsuite/icon-font/lib/people/PeopleBranch';
var PeopleBranch = createSvgIcon({
  as: PeopleBranchSvg,
  ariaLabel: 'people branch',
  category: 'people',
  displayName: 'PeopleBranch'
});
export default PeopleBranch;